import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["queryInput", "submitButton"];
  static values = { createUrl: String };

  declare queryInputTarget: HTMLInputElement;
  declare submitButtonTarget: HTMLButtonElement;
  declare createUrlValue: string;

  async submit() {
    const query = this.queryInputTarget.value.trim();
    if (query.length === 0) return;

    this.disable();
    this.showLoadingOverlay();

    const csrfToken = (document.querySelector('meta[name="csrf-token"]') as HTMLMetaElement)?.content || "";

    try {
      const response = await fetch(this.createUrlValue, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-CSRF-Token": csrfToken
        },
        body: JSON.stringify({ query })
      });

      if (!response.ok) {
        const result = await response.json();
        this.hideOverlay();
        alert(`Fehler: ${result.error || "Unbekannter Fehler"}`);
        this.enable();
      }
    } catch {
      this.hideOverlay();
      alert("Fehler bei der Anfrage. Bitte versuche es erneut.");
      this.enable();
    }
  }

  private showLoadingOverlay() {
    const frame = document.getElementById("discovery_progress_overlay");
    if (!frame) return;
    frame.innerHTML = `
      <div class="fixed inset-0 z-50 flex items-center justify-center bg-white/70 backdrop-blur-sm">
        <div class="relative bg-white rounded-2xl shadow-2xl border border-gray-100 px-10 py-12 max-w-md w-full mx-4 text-center">
          <button type="button" data-discovery-cancel aria-label="Analyse abbrechen"
                  class="absolute top-3 right-3 p-2 text-gray-400 hover:text-gray-600 rounded-lg hover:bg-gray-100 transition-colors">
            <svg class="w-5 h-5" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <line x1="18" y1="6" x2="6" y2="18"></line>
              <line x1="6" y1="6" x2="18" y2="18"></line>
            </svg>
          </button>
          <div class="inline-flex items-center justify-center w-16 h-16 mb-6">
            <svg class="animate-spin w-12 h-12 text-blue-600" viewBox="0 0 24 24" fill="none">
              <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-opacity="0.2" stroke-width="3"></circle>
              <path d="M12 2a10 10 0 0 1 10 10" stroke="currentColor" stroke-width="3" stroke-linecap="round"></path>
            </svg>
          </div>
          <p class="text-lg font-medium text-gray-900 mb-2 min-h-7">Analyse wird gestartet...</p>
          <p class="text-sm text-gray-500">Dies kann 30 bis 60 Sekunden dauern.</p>
        </div>
      </div>
    `;
    frame.querySelector("[data-discovery-cancel]")?.addEventListener("click", () => this.cancel());
  }

  private async cancel() {
    const csrfToken = (document.querySelector('meta[name="csrf-token"]') as HTMLMetaElement)?.content || "";
    try {
      await fetch(`${this.createUrlValue}/cancel`, {
        method: "POST",
        headers: { "X-CSRF-Token": csrfToken }
      });
    } catch {
      // best effort – reload to a clean state regardless
    }
    window.location.reload();
  }

  private hideOverlay() {
    const frame = document.getElementById("discovery_progress_overlay");
    if (frame) frame.innerHTML = "";
  }

  private disable() {
    this.queryInputTarget.disabled = true;
    this.queryInputTarget.classList.add("opacity-60");
    this.submitButtonTarget.disabled = true;
    this.submitButtonTarget.textContent = "Generiere\u2026";
  }

  private enable() {
    this.queryInputTarget.disabled = false;
    this.queryInputTarget.classList.remove("opacity-60");
    this.submitButtonTarget.disabled = false;
    this.submitButtonTarget.textContent = "Analysieren";
  }
}
